(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.querySelector('header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      if (this.headerIsAlwaysSticky) document.documentElement.style.setProperty('--header-top', '0px');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.style.transform = 'translateY(-100%)';
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.style.transform = 'translateY(0)';
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.style.transform = '';
    }
  }

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  const mobileMenuButton = document.querySelector('.pa-mobile-menu');
  const mobileDrawer = document.querySelector('#pa-mobile-drawer');
  const searchModalSource = document.querySelector('.pa-search-modal-source');
  const positionSearchModal = () => {
    if (!searchModalSource) return;
    const headerBottom = document.querySelector('.section-header')?.getBoundingClientRect().bottom || 0;
    const trustBarBottom = document.querySelector('.pa-trust-bar')?.getBoundingClientRect().bottom || 0;
    searchModalSource.style.setProperty('--pa-search-modal-top', `${Math.max(headerBottom, trustBarBottom)}px`);
  };
  positionSearchModal();
  window.addEventListener('resize', positionSearchModal);
  window.addEventListener('scroll', positionSearchModal, { passive: true });

  const closeMobileDrawer = () => {
    if (!mobileDrawer || !mobileMenuButton) return;
    mobileDrawer.classList.remove('is-open');
    mobileDrawer.setAttribute('aria-hidden', 'true');
    mobileMenuButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('pa-mobile-menu-open');
  };

  if (mobileMenuButton && mobileDrawer) {
    mobileMenuButton.addEventListener('click', () => {
      const isOpen = mobileDrawer.classList.toggle('is-open');
      mobileDrawer.setAttribute('aria-hidden', String(!isOpen));
      mobileMenuButton.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('pa-mobile-menu-open', isOpen);
    });
    mobileDrawer.querySelector('.pa-mobile-drawer__overlay')?.addEventListener('click', closeMobileDrawer);
    mobileDrawer.querySelector('.pa-mobile-drawer__close')?.addEventListener('click', closeMobileDrawer);
    mobileDrawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMobileDrawer));
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') closeMobileDrawer();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pushpaura-reviews').forEach((section) => {
    const emptyMessage = section.querySelector('[data-review-empty]');
    if (!emptyMessage) return;

    const updateEmptyMessage = () => {
      const reviewApp = section.querySelector('#AirReviews-BlockWrapper, .AirReviews-Embed-BlockWrapper, .AirReviews-Blocks');
      if (!reviewApp) return;

      const reviewList = reviewApp.querySelector('.AirReviews-Blocks__List');
      if (!reviewList) return;

      const hasReviews = Boolean(reviewList.querySelector('.AirReviews-Blocks__ReviewDetails'));
      emptyMessage.hidden = hasReviews;
    };

    const reviewObserver = new MutationObserver(updateEmptyMessage);
    reviewObserver.observe(section, { childList: true, subtree: true });
    updateEmptyMessage();
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-review-focus]');
    if (!button) return;

    const section = button.closest('.pushpaura-reviews');
    if (!section) return;

    const activateReviewForm = () => {
      const ratingOptions = section.querySelectorAll(
        '.AirReviews-Blocks__ActionRate input[type="radio"], input[type="radio"][id*="star"], input[type="radio"][aria-label*="star" i]'
      );
      const rating = ratingOptions[ratingOptions.length - 1];
      if (!rating) return false;

      rating.click();
      return true;
    };

    if (activateReviewForm()) return;

    // The review app mounts asynchronously, so wait briefly for its rating controls.
    const observer = new MutationObserver(() => {
      if (activateReviewForm()) observer.disconnect();
    });
    observer.observe(section, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 3000);
  });

  } catch(e) { console.error(e); }
})();
})();
